(() => {
  const closest = (el, sel) => (el && el.closest ? el.closest(sel) : null);

  async function addToCart(variantId, qty = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty }),
    });

    if (!res.ok) {
      let msg = 'Falha ao adicionar no carrinho.';
      try {
        const data = await res.json();
        msg = data?.description || data?.message || msg;
      } catch (_) {}
      throw new Error(msg);
    }

    return res.json();
  }

  function getSectionIdFromDrawer() {
    // Pelo teu print: cart-items-component tem data-section-id="sections--...__header_section"
    const el = document.querySelector('cart-items-component[data-section-id]');
    return el?.getAttribute('data-section-id') || null;
  }

  async function refreshDrawerBySectionId() {
    const sectionId = getSectionIdFromDrawer();
    if (!sectionId) return;

    const url = `/?sections=${encodeURIComponent(sectionId)}`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return;

    const json = await res.json();
    const html = json[sectionId];
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Troca APENAS o miolo do drawer, mantendo o componente “vivo”
    const newInner = doc.querySelector('.cart-drawer__inner');
    const curInner = document.querySelector('.cart-drawer__inner');

    if (newInner && curInner) {
      curInner.replaceWith(newInner);
    }

    // Atualiza bolha/contador se existir dentro do header renderizado
    const newBubble =
      doc.querySelector('#cart-icon-bubble') ||
      doc.querySelector('.cart-count-bubble') ||
      doc.querySelector('[data-cart-count]');
    const curBubble =
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.cart-count-bubble') ||
      document.querySelector('[data-cart-count]');

    if (newBubble && curBubble) {
      curBubble.replaceWith(newBubble);
    }
  }

  // SETAS (capture phase pra evitar bloqueio do tema)
  document.addEventListener(
    'click',
    (e) => {
      const prevBtn = closest(e.target, '[data-upsell-prev]');
      const nextBtn = closest(e.target, '[data-upsell-next]');
      if (!prevBtn && !nextBtn) return;

      const root = closest(e.target, '[data-cart-upsells]');
      const track = root && root.querySelector('[data-upsell-track]');
      if (!track) return;

      e.preventDefault();
      e.stopPropagation();

      const step = Math.min(320, track.clientWidth * 0.9) || 280;
      track.scrollBy({ left: prevBtn ? -step : step, behavior: 'smooth' });
    },
    true
  );

  // ADD
  document.addEventListener(
    'click',
    async (e) => {
      const addBtn = closest(e.target, '[data-upsell-add]');
      if (!addBtn) return;

      const item = closest(addBtn, '[data-upsell-item]');
      const variantEl = item && item.querySelector('[data-upsell-variant]');
      const variantId = variantEl && (variantEl.value || variantEl.getAttribute('value'));
      if (!variantId) return;

      e.preventDefault();
      e.stopPropagation();

      const defaultText = addBtn.getAttribute('data-default-text') || 'Adicionar';

      try {
        addBtn.classList.add('is-loading');
        addBtn.textContent = 'Carregando';

        await addToCart(variantId, 1);

        // Re-render do drawer
        await refreshDrawerBySectionId();

        addBtn.textContent = 'Adicionado ✓';
        setTimeout(() => (addBtn.textContent = defaultText), 1200);
      } catch (err) {
        console.error(err);
        addBtn.textContent = 'Erro';
        setTimeout(() => (addBtn.textContent = defaultText), 1500);
      } finally {
        addBtn.classList.remove('is-loading');
      }
    },
    true
  );
 
// ---------- UPSSELL: valida seleção antes de adicionar
document.addEventListener('click', function (e) {
  const addBtn = e.target.closest('[data-upsell-add]');
  if (!addBtn) return;

  const item = addBtn.closest('[data-upsell-item]');
  if (!item) return;

  const select = item.querySelector('select[data-upsell-variant]');
  if (!select) return; // produto com 1 variação

  // se não escolheu variação
  if (!select.value) {
    e.preventDefault();

    select.classList.add('is-error', 'is-shake');

    setTimeout(() => {
      select.classList.remove('is-shake');
    }, 300);

    select.focus();
    return;
  }

  // se escolheu, limpa erro
  select.classList.remove('is-error');
});
document.addEventListener('change', function (e) {
  const select = e.target.closest('select[data-upsell-variant]');
  if (!select) return;

  select.classList.remove('is-error');
});

})();
